import { Validators } from '@angular/forms';
import { UliItemOverviewModel } from './uli-item-overview.model';
import {
  FRACTIONAL_NUMBER_PATTERN,
  NATURAL_NUMBER_PATTERN,
  VALIDATION_RULES,
} from '../../../../../../common/constants';
import { ControlProperty } from '../../../../../../common/models';

export enum UliDetailsViewModeEnum {
  Edit = 'EDIT',
  Read = 'READ',
}

export class UliItemOverviewMainInfoUpdateModel {
  customsGoods = false;
  dangerousGoods = false;
  documentNumbers: string[] = [];
  grossWeight: number = null;
  numberOfHU: number = null;
  numberOfLoadmeters: number = null;

  constructor(params?: UliItemOverviewMainInfoUpdateFormModel) {
    if (params) {
      this.customsGoods = params.customsGoods;
      this.dangerousGoods = params.dangerousGoods;
      this.documentNumbers = params.documentNumbers;
      this.grossWeight = params.grossWeight;
      this.numberOfHU = params.numberOfHU;
      this.numberOfLoadmeters = params.numberOfLoadmeters;
    }
  }
}

export class UliItemOverviewMainInfoUpdateFormModel {
  customsGoods = false;
  dangerousGoods = false;
  documentNumbers: string[] = [];
  grossWeight: number = null;
  numberOfHU: number = null;
  numberOfLoadmeters: number = null;

  constructor(params: UliItemOverviewModel) {
    if (params) {
      const { uliInfo } = params;

      Object.assign(this, uliInfo);
    }
  }
}

export class UliItemOverviewMainInfoUpdateForm {
  constructor(
    model: UliItemOverviewMainInfoUpdateFormModel,
    public customsGoods: ControlProperty<boolean> = [model.customsGoods, []],
    public dangerousGoods: ControlProperty<boolean> = [model.dangerousGoods, []],
    public documentNumbers: ControlProperty<string[]> = [model.documentNumbers, []],
    public grossWeight: ControlProperty<number> = [
      model.grossWeight,
      [
        Validators.pattern(FRACTIONAL_NUMBER_PATTERN),
        Validators.required,
        Validators.maxLength(VALIDATION_RULES.weight.maxLength),
      ],
    ],
    public numberOfHU: ControlProperty<number> = [
      model.numberOfHU,
      [
        Validators.pattern(NATURAL_NUMBER_PATTERN),
        Validators.required,
        Validators.maxLength(VALIDATION_RULES.weight.maxLength),
      ],
    ],
    public numberOfLoadmeters: ControlProperty<number> = [
      model.numberOfLoadmeters,
      [Validators.pattern(FRACTIONAL_NUMBER_PATTERN)],
    ],
  ) {}
}
